import { SystemInfoPage } from "./SystemInfoPage";
export default SystemInfoPage;
